let selectedFiles = []; 

export function contactFormValid(){
    const formSelector = document.querySelector('.ocw-contact-form');
    const spinner = document.querySelector(".loading-spinner");
    const phoneNum = document.querySelector("#phoneNumber");
    const inputField = document.getElementById('lastFourDigits'); 
    const submitBtn =  document.querySelector(".submitContactForm");
    const interestedService = document.querySelectorAll('input[name="interestedInService"]');
    if (!phoneNum || !formSelector || !inputField || !submitBtn || !interestedService) {
      return;
    }
    
    console.log(interestedService)
    phoneNum.addEventListener("input", (e) => {
      let currVal = e.currentTarget.value.replace(/\D/g, "");
      if (currVal.length <= 3) {
        e.currentTarget.value = currVal;
      } else if (currVal.length <= 6) {
        e.currentTarget.value = currVal.slice(0, 3) + "-" + currVal.slice(3);
      } else {
        e.currentTarget.value =
          currVal.slice(0, 3) +
          "-" +
          currVal.slice(3, 6) +
          "-" +
          currVal.slice(6, 10);
      }
    }); 

    inputField.addEventListener('input', function() {
        let value = inputField.value.replace(/\D/g, '');

        if (value.length > 4) {
            value = value.substring(0, 4);
        }

        inputField.value = value;
    });
    interestedService.forEach(radioButton => {
      radioButton.addEventListener('change', (e) => {
          const phoneLabel = document.querySelector('label[for="phoneNumber"]');
          if( e.target.value === 'savings' ){
            document.querySelector('.subject-container').style.display = '';
            document.getElementById('lastFourDigits').parentElement.style.display = 'none';
            document.getElementById('address').value = '';
            document.getElementById('lastFourDigits').value = '';
            document.getElementById('address').parentElement.style.display = 'none';
            document.getElementById('address').parentElement.parentElement.classList.add('two-col');
            document.getElementById('address').parentElement.parentElement.classList.remove('three-col');
            document.getElementById('subjectSelect').parentElement.style.display = 'none';
            if (phoneLabel) {
              phoneLabel.textContent = phoneLabel.textContent.replace('*', '').trim();
            }
          } else{
            document.querySelector('.subject-container').style.display = 'none';
            document.querySelector('#subject').value = '';
            document.getElementById('lastFourDigits').parentElement.style.display = '';
            document.getElementById('address').parentElement.style.display = '';
            document.getElementById('address').parentElement.parentElement.classList.remove('two-col');
            document.getElementById('address').parentElement.parentElement.classList.add('three-col');
            document.getElementById('subjectSelect').parentElement.style.display = '';
            if (phoneLabel && !phoneLabel.textContent.includes('*')) {
              phoneLabel.textContent += '*';
            }
          }
      });
    });
    
    submitBtn.addEventListener("click", (e) => {
      e.preventDefault();
      spinner.style.display = 'flex'; 

      const errors = []; // Array para almacenar los errores
      const fullName = document.querySelector('#fullName').value.trim();
      const email = document.querySelector('#email').value.trim();
      const phoneNumber = document.querySelector('#phoneNumber').value.trim();
      const address = document.querySelector('#address').value.trim();
      const lastFourDigits = document.querySelector('#lastFourDigits').value.trim();
      const message = document.querySelector('#message').value.trim();
      const contactLang = document.querySelector('#contactLang').value.trim();
      const subject = document.querySelector('#subject').value.trim();
      const interestedService = document.querySelector('input[name="interestedInService"]:checked');
      const phoneRegex = /^\(?[2-9]\d\d\)?[\s-]?([2-9](?!11)[0-9]{2})[\s-]?([0-9]{4})/;
      const regex = /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ,.0-9 ]+$/;
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      // Validaciones
      if (!interestedService) {
          errors.push({ field: "interestedInService", message: "Please select a service." });
      }

      if (!fullName || !regex.test(fullName)) {
          errors.push({ field: "fullName", message: "Please enter a valid full name." });
      }

      if (!email || !emailPattern.test(email)) {
          errors.push({ field: "email", message: "Please enter a valid email address." });
      }

      if (interestedService && interestedService.value === 'personal-loans' && (!phoneNumber || !phoneRegex.test(phoneNumber))) {
          errors.push({ field: "phone", message: "Please enter a valid phone number." });
      }

      if (interestedService && interestedService.value === 'savings' && (!subject || !regex.test(subject))) {
          errors.push({ field: "subject", message: "Please enter a valid subject." });
      }

      if (!message || !regex.test(message)) {
          errors.push({ field: "message", message: "Please enter a valid message." });
      }

      // show errors if exist
      if (errors.length > 0) {
          errors.forEach(error => {
              const errorElement = document.querySelector(`.input-error.${error.field}`);
              if (errorElement) {
                  errorElement.textContent = error.message;
                  errorElement.style.display = "block";
                  setTimeout(() => {
                      errorElement.style.display = "none";
                  }, 3500);
              }
          });

          if (spinner) {
              spinner.style.display = 'none';
          }
          return false; // stop form submission
      }

      // If no errors, continue with submission
      const currUrl = window.location.origin + "/wp-json/ocw-contact-form/contact/";
      const formData = new FormData();
      formData.append("interestedService", interestedService.value);
      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("address", address);
      formData.append("phoneNumber", phoneNumber);
      formData.append("lastFourDigits", lastFourDigits);
      formData.append("subject", subject);
      formData.append("message", message);
      formData.append("contactLang", contactLang);

      fetch(currUrl, { method: "POST", body: formData })
          .then(response => {
              if (response.status === 200) {
                  return response.json();
              } else {
                  throw new Error(`Error: ${response.status}`);
              }
          })
          .then(data => {
              if (data === 'sent') {
                  document.querySelector(".modal-success-msg").style.display = "flex";
                  setTimeout(() => {
                      document.querySelector(".modal-success-msg").style.display = "none";
                  }, 5000);
                  if (spinner) {
                      spinner.style.display = 'none';
                  }
                  document.querySelector('#fullName').value = '';
                  document.querySelector('#email').value = '';
                  document.querySelector('#phoneNumber').value = '';
                  document.querySelector('#address').value = '';
                  document.querySelector('#lastFourDigits').value = '';
                  document.querySelector('#message').value = '';
                  document.querySelector('#subject').value = '';
                  clearAttachments();
              } else if (data.code === 409) {
                  document.querySelector(".modal-error-msg").style.display = "flex";
                  if (spinner) {
                      spinner.style.display = 'none';
                  }
                  setTimeout(() => {
                      document.querySelector(".modal-error-msg").style.display = "none";
                  }, 5000);
                  console.error("Error:", data.message);
              }
          })
          .catch(error => {
              document.querySelector(".modal-error-msg").style.display = "flex";
              if (spinner) {
                  spinner.style.display = 'none';
              }
              setTimeout(() => {
                  document.querySelector(".modal-error-msg").style.display = "none";
              }, 5000);
              console.error("Error:", error);
          });
  });

}

export function contactFormAttachment() {
  const dropzone = document.getElementById('upload-dropzone');
  const fileInput = document.getElementById('contactform-attachments');
  const uploadedFilesList = document.createElement('ul');

  if (!dropzone || !fileInput || !uploadedFilesList) {
      return;
  }

  uploadedFilesList.classList.add('uploaded-files');
  dropzone.parentNode.insertBefore(uploadedFilesList, dropzone.nextSibling);

  dropzone.addEventListener('click', () => {
      fileInput.click();
  });

  dropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropzone.classList.add('dragging');
  });

  dropzone.addEventListener('dragleave', () => {
      dropzone.classList.remove('dragging');
  });

  dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropzone.classList.remove('dragging');
      handleFiles(e.dataTransfer.files);
  });

  fileInput.addEventListener('change', () => {
      handleFiles(fileInput.files);
  });

  function handleFiles(files) {
      const maxFileSize = 5 * 1024 * 1024; // 5 MB en bytes
      Array.from(files).forEach((file) => {
          
          if (selectedFiles.some(f => f.name === file.name && f.size === file.size)) {
              const errorMessage = `The file "${file.name}" has already been added.`;
              document.querySelector('.input-error.attachments .error').textContent = errorMessage;
              document.querySelector('.input-error.attachments').style.display = 'block';
              setTimeout(() => {
                  document.querySelector('.input-error.attachments').style.display = 'none';
              }, 3000);
              return; 
          }

          if (file.size > maxFileSize) {
              const errorMessage = `The file "${file.name}" exceeds the 5MB size limit and will not be uploaded.`;
              document.querySelector('.input-error.attachments .error').textContent = errorMessage;
              document.querySelector('.input-error.attachments').style.display = 'block';
              setTimeout(() => {
                  document.querySelector('.input-error.attachments').style.display = 'none';
              }, 3000);
              return; // Saltar este archivo
          }

          
          selectedFiles.push(file);

          
          const listItem = document.createElement('li');
          listItem.textContent = file.name;

          const removeButton = document.createElement('span');
          removeButton.innerHTML = '<oportun-icon name="close"></oportun-icon>';
          removeButton.classList.add('remove-file');
          removeButton.addEventListener('click', () => {
              listItem.remove();
              
              selectedFiles = selectedFiles.filter(f => f !== file);
          });

          listItem.appendChild(removeButton);
          uploadedFilesList.appendChild(listItem);
      });
  }
}

function clearAttachments() {
  const uploadedFilesList = document.querySelector('.uploaded-files');
  if (uploadedFilesList) {
      uploadedFilesList.innerHTML = ''; 
  }
  const fileInput = document.getElementById('contactform-attachments');
  if (fileInput) {
      fileInput.value = '';
  }
  selectedFiles = [];
}